<script setup>
import {RouterView} from 'vue-router'
import {watch} from 'vue'
import {useI18n} from 'vue-i18n'

const {locale} = useI18n({useScope: 'global'})

// Keep the document language in sync so screen readers and hyphenation follow
// the switcher.
watch(locale, lc => document.documentElement.setAttribute('lang', lc), {immediate: true})
</script>

<template>
  <router-view/>
</template>
